var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "cb-entities" } },
    [
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "entities-container" }, [
          _c("div", { staticClass: "header" }, [
            _c("div", { staticClass: "left" }, [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("chatbotv2.entities"))),
              ]),
              _vm._v(" "),
              _vm.checkPermission(
                _vm.PERMISSION_TYPES["chatbot.entities.create"].tr.name
              )
                ? _c(
                    "div",
                    {
                      staticClass: "icon-container",
                      on: {
                        click: function ($event) {
                          _vm.createModal = true
                        },
                      },
                    },
                    [_c("md-icon", [_vm._v("add")])],
                    1
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "right" }, [
              _c(
                "div",
                { staticClass: "input-container", attrs: { tabindex: "0" } },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.search,
                        expression: "search",
                      },
                    ],
                    attrs: { placeholder: _vm.$t("visitor.search") },
                    domProps: { value: _vm.search },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.search = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("md-icon", [_vm._v("search")]),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "entities" }, [
            _c(
              "div",
              { staticClass: "entities-list-wrapper" },
              _vm._l(
                _vm.search ? _vm.searchArray : _vm.entities,
                function (entitie, index) {
                  return _c(
                    "div",
                    {
                      key: entitie.name,
                      staticClass: "entities-list-item",
                      on: {
                        click: function ($event) {
                          _vm.updateModal = entitie._id
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "name" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(entitie.name) +
                            "\n                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.checkPermission(
                        _vm.PERMISSION_TYPES["chatbot.entities.delete"].tr.name
                      )
                        ? _c(
                            "div",
                            {
                              staticClass: "delete-icon",
                              on: {
                                click: function (e) {
                                  return _vm.deleteButtonClickHandler(
                                    e,
                                    entitie._id
                                  )
                                },
                              },
                            },
                            [_c("md-icon", [_vm._v("delete_outline")])],
                            1
                          )
                        : _vm._e(),
                    ]
                  )
                }
              ),
              0
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.createModal
        ? _c("EntriesForm", {
            on: {
              cancel: function ($event) {
                _vm.createModal = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.updateModal
        ? _c("EntriesForm", {
            attrs: { id: _vm.updateModal },
            on: {
              cancel: function ($event) {
                _vm.updateModal = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }